import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

import "../styles/devices.css";
import MouseFooter from "../components/MouseFooter";
import BackgroundCanvas from "../components/BackgroundCanvas";

export default function Devices() {
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
  
    // 👇 close menu whenever route changes
    useEffect(() => {
        setMenuOpen(false);
      }, [location]);
  
    const goToSection = (e, id) => {
      e.preventDefault();
      navigate("/"); // go back to home first
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    };

  return (
    <>
      {/* Background canvas */}
      <BackgroundCanvas />
      <div className="devices-darken" />

      {/* Navbar */}
      <header className="navbar relative z-10">
      <div className="logo">
      <Link
        to="/"
        onClick={() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      >
        <img src="/ego.png" alt="Ego Blockchain Logo" className="logo-img" />
      </Link>
    </div>

        {/* Hamburger button */}
        <button
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Nav links */}
        <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
          <Link to="/download" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            Download Ego Desktop
          </Link>
          <Link to="/blog" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            Blog
          </Link>
          <Link to="/docs" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            Docs
          </Link>
          <Link to="/egoscan" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            EgoScan
          </Link>
          <Link to="/claim" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            Claim EGOC
          </Link>
        </nav>
      </header>

            {/* Overlay (click to close) */}
            {menuOpen && (
        <div className="menu-overlay" onClick={() => setMenuOpen(false)} />
      )}

      {/* Devices Page */}
      {/* Devices Page */}
      <section className="devices container mx-auto px-4 py-12">
            <div className="device-hero">
                <img src="/egodevice.png" alt="Ego 5G Device" className="device-img" />
                <div className="connection-bg"></div>
            </div>

            <h1 className="text-3xl font-bold mb-6">Ego 5G Device</h1>
            <p className="mb-8">
                Your portable, carrier-compliant node for real-world coverage and
                verifiable storage.
            </p>

        <h2 className="text-2xl font-semibold mt-6 mb-2">What it is</h2>
        <ul className="list-disc pl-6 mb-6">
          <li>
            A purpose-built, portable 5G unit engineered to run the Ego node
            natively.
          </li>
          <li>
            Designed to prove wireless coverage (PoC) and provide verifiable
            storage (PoRep + PoSt) with low cellular data use.
          </li>
          <li>
            Works wherever your SIM/eSIM has service; prefers home/office
            Ethernet or Wi-Fi for heavy tasks.
          </li>
          <li>
            Available to early operators via an invite-only pilot. Features roll
            out in phases with signed OTA updates.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold mt-6 mb-2">What it does</h2>
        <ul className="list-disc pl-6 mb-6">
          <li>
            Proof of Coverage (PoC): Listens to live 5G signals and publishes
            cryptographically signed coverage evidence.
          </li>
          <li>
            Verifiable Storage: Stores encrypted data and answers randomized
            audits to prove uptime and availability for rewards.
          </li>
          <li>
            Self-Healing Replication: Keeps three independent copies online,
            repairing automatically if one goes offline.
          </li>
          <li>
            Smart Networking: Uses Wi-Fi/Ethernet first for big uploads, keeps
            cellular usage lean.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold mt-6 mb-2">
          Why it’s different
        </h2>
        <ul className="list-disc pl-6 mb-6">
          <li>Ego-only hardware: Only certified Ego devices operate as nodes.</li>
          <li>
            PQC-secure by default: Post-quantum cryptography for attestations
            and proofs.
          </li>
          <li>
            Cellular-safe design: Meta-events on cellular, bulk uploads deferred
            to Wi-Fi.
          </li>
          <li>
            Fast finality: Regional rollups and sharded consensus finalize in
            seconds.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold mt-6 mb-2">
          How it works with the network
        </h2>
        <ul className="list-disc pl-6 mb-6">
          <li>
            <strong>Measure and Prove Coverage:</strong> Device captures 5G RF
            metrics + GNSS, publishes signed coverage reports.
          </li>
          <li>
            <strong>Store and Prove Data:</strong> Seals encrypted replicas and
            answers unpredictable audits.
          </li>
          <li>
            <strong>Deterministic Rewards:</strong> Payouts are based on valid
            proofs and service quality.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold mt-6 mb-2">Set up in minutes</h2>
        <ul className="list-disc pl-6 mb-6">
          <li>Insert SIM/eSIM and power on.</li>
          <li>Connect via the web app to choose your role.</li>
          <li>Link your Ego account and follow the setup wizard.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-6 mb-2">
          Designed for real life
        </h2>
        <ul className="list-disc pl-6 mb-6">
          <li>Portable, silent, battery + 12 V support.</li>
          <li>Great for home, office, or mobile use.</li>
          <li>Status indicators for power, WAN, Wi-Fi, GNSS, and battery.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-6 mb-2">
          Compliance and safety
        </h2>
        <ul className="list-disc pl-6 mb-6">
          <li>
            Operator-compliant PoC on licensed 5G (no unauthorized
            transmissions).
          </li>
          <li>Anti-replay via passive cellular + side-channel nonce.</li>
          <li>Enforces carrier Terms of Service by default.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-6 mb-2">What’s included</h2>
        <ul className="list-disc pl-6 mb-6">
          <li>Ego 5G Device (portable node)</li>
          <li>USB-C power input and quick-start guide</li>
          <li>Web-based setup and dashboard</li>
          <li>Ongoing, signed firmware updates</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-6 mb-2">Who it’s for</h2>
        <ul className="list-disc pl-6 mb-6">
          <li>Home/office operators seeking predictable rewards.</li>
          <li>Mobile/field users (vehicles, pop-ups).</li>
          <li>
            Community builders who want trusted coverage + storage.
          </li>
        </ul>
      </section>

      <MouseFooter />
    </>
  );
}
